module.exports = __webpack_public_path__ + "img/portada7.88aa9f9f.svg";